import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPartRequest,
  getNewPartRequests,
  getActivePartRequests,
  getCompletedPartRequests,
  getArchivedPartRequests,
} from "../../reduxStore/entities/partRequest";

export default function useRequestData(selectedTab, showArchived, requestPage, requestRowsPerPage) {
  const dispatch = useDispatch();

  const requestData = useSelector((state) => state.partRequests.allPartRequest?.rows || []);
  const activePartRequests = useSelector((state) => state.partRequests.activePartRequests?.rows || []);
  const completedPartRequests = useSelector((state) => state.partRequests.completedPartRequests?.rows || []);
  const archivedPartRequests = useSelector((state) => state.partRequests.archivedPartRequests?.rows || []);
  const newRequests = useSelector((state) => state.partRequests.newPartRequests?.rows || []);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      await dispatch(getNewPartRequests({
        limit: requestRowsPerPage,
        offset: requestPage * requestRowsPerPage,
      }));


      await dispatch(getAllPartRequest({ state: [] }));
      await dispatch(getActivePartRequests({ state: [1, 2, 16] }));
      await dispatch(getCompletedPartRequests({
        state: Array.from({ length: 18 }, (_, i) => i).filter(x => ![1, 2, 4, 16].includes(x)),
      }));
      await dispatch(getArchivedPartRequests({ state: [4] }));

      setLoading(false);
    };

    fetchData();
  }, [dispatch, requestPage, requestRowsPerPage, selectedTab]);



  const fetchTabData = async (selectedTab) => {

    if (selectedTab === "aktivni") {
      await dispatch(getActivePartRequests({ state: [1, 2, 16] }));
    } else if (selectedTab === "zavrseni") {
      await dispatch(getCompletedPartRequests({
        state: Array.from({ length: 18 }, (_, i) => i).filter(x => ![1, 2, 4, 16].includes(x))
      }));
    } else if (selectedTab === "svi") {
      await dispatch(getAllPartRequest({ state: [] }));
    }

  };

  const fetchArchived = async () => {
    if (!showArchived) {
      await dispatch(getArchivedPartRequests({ limit: 100, offset: 0 }));
    }
  };

  return {
    loading,
    requestData,
    newRequests,
    activePartRequests,
    completedPartRequests,
    archivedPartRequests,
    fetchTabData,
    fetchArchived,
  };
}
